import { UnauthorizedError } from "../models/unauthorized.error";
import {
  authRedirect
} from '../utils/redirect.utils';

const authErrorInterceptor = (response: Response) => {
  if (response.status === 401) {
    authRedirect();
  }
  throw response;
};

export const fetchAuthErrorInterceptor = (response: Response) => {
  return authErrorInterceptor(response);
};

const authErrorInterceptorServiceWorker = (response: Response) => {
  if (response.status === 401) {
    throw new UnauthorizedError("");
  }
};

export const fetchAuthErrorInterceptorServiceWorker = (response: Response) => {
  authErrorInterceptorServiceWorker(response);
  return response;
};

